module.exports = __webpack_public_path__ + "img/Flag_of_Azerbaijan.0980ddc7.svg";